import Base from './base'
import _ from 'underscore'
import URI from 'urijs'

/*
 * Lab features for a user
 *
 * @example Usage
 *   import User from '@polleverywhere/core/lib/models/user'
 *   import LabFeatures from '@polleverywhere/core/lib/models/lab_features'
 *   ...
 *   const user = new User({ id: 2 })
 *   const labs = new LabFeatures({ user: user })
 *   labs.save({ boring: true })
 *
 * @namespace Model
 */
export default class LabFeatures extends Base {
  /*
   * Constructor
   * @param [Object] options Options
   * @option options [Model] user User to fetch lab features for
   */
  constructor (options) {
    super()
    if (options == null) { options = {} }
    this.user = options.user
  }

  url () {
    return URI('/api/users').segment(this.user.id.toString()).segment('labs').toString()
  }

  // Override backbone isNew to honor save(patch: true)
  isNew () { return false }

  /*
   * Send a PATCH request to server to save the lab features
   *
   * @param [Object] features Features to turn on/off
   * @param [Object] options Any options to use with the save/sync attempt
   */
  save (features = {}, options = {}) {
    _.extend(options, { patch: true }) // force patch request

    return super.save(features, options)
  }
}
